import { makeAutoObservable } from "mobx";

export default class NBaseline {
  constructor(
    baselineNumber,
    dateEffective,
    preBaselinePeriod,
    unqPreBaslineId
  ) {
    this.baselineNumber = baselineNumber;
    this.dateEffective = dateEffective;
    this.preBaselinePeriod = preBaselinePeriod;
    this.unqPreBaslineId = unqPreBaslineId;

    makeAutoObservable(this);
  }

  toJS() {
    return {
      baselineNumber: this.baselineNumber,
      dateEffective: this.dateEffective,
      preBaselinePeriod: this.preBaselinePeriod,
      unqPreBaslineId: this.unqPreBaslineId,
    };
  }

  static fromJS(object) {
    const nBaseline = new NBaseline();
    if (object !== null) {
      nBaseline.baselineNumber = object.baselineNumber;
      nBaseline.dateEffective = object.dateEffective;
      nBaseline.preBaselinePeriod = object.preBaselinePeriod;
      nBaseline.unqPreBaslineId = object.unqPreBaslineId;
    }
    return nBaseline;
  }
}
